import { render, staticRenderFns } from "./s-info-modifiable.vue?vue&type=template&id=4e1c6b82&scoped=true"
import script from "./s-info-modifiable.vue?vue&type=script&lang=js"
export * from "./s-info-modifiable.vue?vue&type=script&lang=js"
import style0 from "./s-info-modifiable.vue?vue&type=style&index=0&id=4e1c6b82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1c6b82",
  null
  
)

export default component.exports